// extracted by mini-css-extract-plugin
export default {"confirmModal":"WniPIPJa","heading":"_tzgpkBw","text":"gzmvNDZU","input":"oHluTe6z","controls":"u_D9s1Jc","button":"NsWErM4T"};